<template>
  <div class="header">
    <div class="logo">
      <router-link to="/">
        <img src="../assets/logo.png" alt="Logo" />
      </router-link>
    </div>
    <div class="header-content main-content">
      <nav class="nav-menu" ref="navMenu" :style="{
        'padding-left':
          windowWidth - 1328 > 356
            ? '0px'
            : 356 + 1328 - windowWidth > 300
              ? 200 + 'px'
              : (356 + 1328 - windowWidth) / 2 + 'px',
      }">
        <div class="nav-indicator" ref="navIndicator"></div>
        <ul>
          <li class="solution-menu" :class="{ active: isSolutionActive, open: isSolutionOpen }"
            @mouseenter="openSolutionMenu" @mouseleave="closeSolutionMenu">
            <a href="javascript:;" :class="{ active: isSolutionActive }">产品方案</a>
            <div class="solution-dropdown">
              <div class="solution-tabs">
                <button v-for="group in solutionMenus" :key="group.key" type="button" class="solution-tab"
                  :class="{ active: activeSolutionKey === group.key }" @mouseenter="activeSolutionKey = group.key">
                  {{ group.name }}
                </button>
              </div>
              <div class="solution-list" :class="{ single: activeSolutionItems.length === 1 }">
                <router-link v-for="item in activeSolutionItems" :key="item.path" :to="item.path" class="solution-item"
                  :class="{ active: isPathActive(item.path) }" @click.native="closeSolutionMenu">
                  <span class="solution-title">{{ item.name }}</span>
                  <span class="solution-desc">{{ item.desc }}</span>
                </router-link>
              </div>
            </div>
          </li>
          <li v-for="item in standaloneMenus" :key="item.path">
            <router-link :to="item.path" active-class="active" :class="{ active: isStandaloneActive(item.path) }">
              {{ item.name }}
            </router-link>
          </li>
        </ul>
      </nav>
      <div class="contact">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" fill="none">
          <g clip-path="url(#clip0_2152_909)">
            <circle cx="12" cy="12.5" r="11" stroke="url(#paint0_linear_2152_909)" stroke-width="1.5" />
            <path
              d="M9.66591 7.06152C9.90811 7.06152 10.1312 7.19286 10.2488 7.40461L11.0643 8.87355C11.171 9.06588 11.1761 9.29851 11.0777 9.49528L10.2921 11.0665C10.2921 11.0665 10.5197 12.237 11.4725 13.1898C12.4253 14.1426 13.5919 14.3663 13.5919 14.3663L15.1629 13.5808C15.3598 13.4824 15.5926 13.4875 15.785 13.5944L17.2581 14.4134C17.4696 14.5311 17.6008 14.7541 17.6008 14.9961V16.6873C17.6008 17.5485 16.8008 18.1705 15.9848 17.8952C14.3088 17.3297 11.7073 16.2529 10.0583 14.604C8.40938 12.955 7.33265 10.3535 6.76714 8.67751C6.4918 7.86148 7.11383 7.06152 7.97505 7.06152H9.66591Z"
              stroke="url(#paint1_linear_2152_909)" stroke-width="1.5" stroke-linejoin="round" />
          </g>
          <defs>
            <linearGradient id="paint0_linear_2152_909" x1="19.5" y1="21.5" x2="6" y2="2.5"
              gradientUnits="userSpaceOnUse">
              <stop stop-color="#1CB3B8" />
              <stop offset="1" stop-color="#386FC6" />
            </linearGradient>
            <linearGradient id="paint1_linear_2152_909" x1="18" y1="17.5" x2="7.5" y2="6.5"
              gradientUnits="userSpaceOnUse">
              <stop stop-color="#1CB3B8" />
              <stop offset="1" stop-color="#386FC6" />
            </linearGradient>
            <clipPath id="clip0_2152_909">
              <rect width="24" height="24" fill="white" transform="translate(0 0.5)" />
            </clipPath>
          </defs>
        </svg>
        <span class="phone"> {{ companyInfo.phone }} </span>
      </div>
    </div>
  </div>
</template>

<script>
import { companyInfo } from '@/config';

export default {
  name: "HeaderSection",
  data() {
    return {
      activeIndex: this.$route.path,
      prevActiveItem: null,
      windowWidth: window.innerWidth,
      hoveredSolutionKey: "",
      isSolutionOpen: false,
      solutionMenus: [

        {
          key: "medical",
          name: "智慧医保",
          items: [
            {
              name: "医保基金智能监管系统",
              path: "/medical",
              desc: "降低医保违规风险，提升医保监管水平",
            },
            {
              name: "医保结算清单质控系统",
              path: "/medical-control",
              desc: "高效质控，结算无忧",
            },
            {
              name: "DRG/DIP院内综合管理平台",
              path: "/drg-platform",
              desc: "辅助医院做好DRG/DIP精细化运营管理",
            },
            {
              name: "门诊APG管理系统",
              path: "/apg-management",
              desc: "门诊医保“打包付费”与医院精细化管理的新型医保支付工具",
            },
            {
              name: "合理诊疗智慧监管系统",
              path: "/reasonable-treatment",
              desc: "聚焦医疗行为的智能监测、风险预警及违规拦截",
            },
          ],
        },
        {
          key: "operation",
          name: "智慧运营",
          items: [
            {
              name: "智慧运营管理平台",
              path: "/operate",
              desc: "以异常自动发现为入口，通过知识图谱下钻根因、AI Agent生成可执行建议形成“发现—归因—行动—回溯”的医院运营管理闭环，帮助管理者提前一个管理周期预警、精准决策、量化效果。",
            },
          ],
        },
        {
          key: "serve",
          name: "智慧服务",
          items: [
            {
              name: "互联网医院平台",
              path: "/internet-hospital",
              desc: "就医流程优化再造，提供线上线下一体化服务",
            },
            {
              name: "统一预约平台",
              path: "/reserve",
              desc: "整合预约资源，提供全场景预约服务",
            },
            {
              name: "远程医疗系统",
              path: "/remote-medical",
              desc: "贯通区域医疗通道，均衡区域医疗服务能力",
            },
            {
              name: "患者就医全流程消息指引系统",
              path: "/guild",
              desc: "实时推送节点化指引，降低就医流程认知成本",
            },
            {
              name: "统一支付对账平台",
              path: "/pay-check",
              desc: "打通多渠道全链路结算通道，提供一体化对账管理能力",
            },
            {
              name: "患者诊后健康管理平台",
              path: "/health",
              desc: "延伸健康服务宽度，构建全病程健康服务",
            },
          ],
        },
        {
          key: "smart",
          name: "智能运维",
          items: [
            {
              name: "数字化运维监控系统",
              path: "/smart",
              desc: "业务健康稳定运行的守护者",
            },
            {
              name: "IT服务流程管理系统",
              path: "/it-service",
              desc: "聚焦IT管理落实，着力制度流程化",
            },
          ],
        },
      ],
    };
  },
  computed: {
    companyInfo() {
      return companyInfo;
    },
    standaloneMenus() {
      return [
        { name: "培训认证", path: "/training" },
        { name: "新闻中心", path: "/news" },
        { name: "关于我们", path: "/about" },
        { name: "加入我们", path: "/join" },
        { name: "免费试用", path: "/free" },
      ];
    },
    currentSolutionKey() {
      const path = this.$route.path;
      const group = this.solutionMenus.find(menu =>
        menu.items.some(item => item.path !== "/" && this.isPathMatch(path, item.path))
      );
      return group ? group.key : "";
    },
    activeSolutionKey: {
      get() {
        return this.hoveredSolutionKey || this.currentSolutionKey || "medical";
      },
      set(value) {
        this.hoveredSolutionKey = value;
      },
    },
    activeSolutionItems() {
      const activeGroup = this.solutionMenus.find(item => item.key === this.activeSolutionKey);
      return activeGroup ? activeGroup.items : [];
    },
    isSolutionActive() {
      return Boolean(this.currentSolutionKey);
    },
  },
  watch: {
    $route(to) {
      this.activeIndex = to.path;
      this.hoveredSolutionKey = "";
      this.isSolutionOpen = false;
      this.$nextTick(() => {
        this.updateNavIndicator();
      });
    },
  },
  methods: {
    handleResize() {
      this.windowWidth = window.innerWidth;
    },
    openSolutionMenu() {
      this.isSolutionOpen = true;
    },
    closeSolutionMenu() {
      this.isSolutionOpen = false;
    },
    isPathMatch(currentPath, targetPath) {
      if (targetPath === "/") {
        return currentPath === "/";
      }
      return currentPath === targetPath;
    },
    isPathActive(path) {
      return this.isPathMatch(this.$route.path, path);
    },
    isStandaloneActive(path) {
      if (path === "/news") {
        return this.$route.path === "/news" || this.$route.path === "/news-detail";
      }
      return this.isPathMatch(this.$route.path, path);
    },
    updateNavIndicator() {
      const activeItem = this.$el.querySelector(".nav-menu > ul > li > a.active");

      if (activeItem) {
        const navIndicator = this.$refs.navIndicator;
        const rect = activeItem.getBoundingClientRect();
        const navRect = this.$refs.navMenu.getBoundingClientRect();
        if (navIndicator) {
          navIndicator.style.width = `${rect.width - 20}px`;
          navIndicator.style.left = `${rect.left - navRect.left + 10}px`;
        }

        this.prevActiveItem = activeItem;
      } else {
        const navIndicator = this.$refs.navIndicator;
        if (navIndicator) {
          navIndicator.style.width = `0px`;
          navIndicator.style.left = `0px`;
        }
      }
    },
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
    this.$nextTick(() => {
      this.updateNavIndicator();

      // 监听窗口大小变化，更新指示器位置
      window.addEventListener("resize", this.updateNavIndicator);
    });
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.handleResize);
    window.removeEventListener("resize", this.updateNavIndicator);
  },
};
</script>
<style scoped>
.nav-menu {
  font-family: "PingFang SC";
  flex: 1;
  position: relative;
}

.nav-menu ul {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
}

.nav-menu ul li {
  position: relative;
  margin: 0 16px;
}

.nav-menu ul li:first-child {
  margin-left: 0;
}

.nav-menu ul li a {
  display: block;
  color: #1f2329;
  font-size: 16px;
  font-weight: 500;
  line-height: 64px;
  text-decoration: none;
  padding: 0 10px;
}

.nav-menu ul li a:hover,
.nav-menu ul li a.router-link-active,
.nav-menu ul li a.active {
  color: #1cb3b8;
}


/* 添加下划线指示器 */
.nav-indicator {
  position: absolute;
  bottom: 10px;
  height: 2px;
  background-color: #1cb3b8;
  transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
  z-index: 1;
}

.solution-menu {
  position: static !important;
}

.solution-dropdown {
  position: fixed;
  top: 64px;
  left: 0;
  right: 0;
  width: 100%;
  min-height: 184px;
  background: #fff;
  box-shadow: 0 10px 28px rgba(24, 39, 75, 0.16);
  display: flex;
  visibility: hidden;
  opacity: 0;
  transform: translateY(-8px);
  transition: opacity 0.25s ease, transform 0.25s ease, visibility 0.25s ease;
  z-index: 998;
}

.solution-menu.open .solution-dropdown {
  visibility: visible;
  opacity: 1;
  transform: translateY(0);
}

.solution-tabs {
  width: 170px;
  flex: 0 0 170px;
  background: #f5f8fc;
  padding: 12px 0;
}

.solution-tab {
  width: 100%;
  height: 40px;
  border: 0;
  background: transparent;
  color: #1f2329;
  cursor: pointer;
  font-family: "PingFang SC";
  font-size: 16px;
  font-weight: 600;
  line-height: 40px;
  text-align: right;
  padding: 0 28px 0 12px;
}

.solution-tab:hover,
.solution-tab.active {
  color: #1cb3b8;
  background: #eefbfa;
}

.solution-list {
  flex: 1;
  display: grid;
  grid-template-columns: repeat(3, minmax(220px, 1fr));
  align-content: start;
  column-gap: 86px;
  row-gap: 24px;
  padding: 28px 36px 34px;
}

.solution-list.single {
  grid-template-columns: 1fr;
  column-gap: 0;
}

.solution-item {
  display: flex !important;
  flex-direction: column;
  min-width: 0;
  color: #53627c !important;
  line-height: 1.5 !important;
  padding: 0 !important;
}

.solution-item:hover .solution-title,
.solution-item.active .solution-title {
  color: #1cb3b8;
}

.solution-title {
  color: #50627f;
  font-size: 15px;
  font-weight: 500;
  line-height: 22px;
  white-space: normal;
}

.solution-desc {
  color: #929eb0;
  font-size: 13px;
  font-weight: 400;
  line-height: 20px;
  margin-top: 2px;
  white-space: normal;
}

.header {
  width: 100%;
  border-bottom: 1px solid #fff;
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(12.5px);
  height: 64px;
  position: fixed;
  top: 0;
  z-index: 999;
  display: flex;
}

.header-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 64px;
  align-content: center;
}

.logo img {
  position: fixed;
  top: 0;
  left: 32px;
  height: 64px;
  cursor: pointer;
}

.nav-menu {
  border-bottom: none;
  background-color: transparent;
  border: none !important;
}

::v-deep .nav-menu .el-submenu__title,
.nav-menu li {
  font-family: "PingFang SC";
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 64px !important;
  border: none;
}

.contact {
  font-family: "PingFang SC";
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  background: linear-gradient(272deg, #1cb3b8 0.61%, #386fc6 100%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  display: flex;
  align-items: center;
}

.phone {
  font-weight: bold;
  margin-left: 8px;
}

a {
  text-decoration: none;
}
</style>
